import { Fragment, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import Select from 'react-select';
import { connect } from 'react-redux';
import { apiEndpoint } from './constants/api';
import { genderOptions } from'./constants/genderOptions';
import { UserSearchTable } from './components/UserSearchTable';
import Header from './components/Header';
import Aside from './components/Aside';
import ProdzFooter from './components/Footer';
import Nav from './components/Nav';

const connector = connect((state, ownProps) => ({ 
 ...state.user,
 employer: state.user.currentEmployer
}), {});
function UserSearch({ user, employer }) {
  const [userData, setUserData] = useState([]);
  const [ethnicities, setEthnicities] = useState([]);
  const [skills, setSkills] = useState([]);
  const [query, setQuery] = useState('');
  const [skillQuery, setSkillQuery] = useState('');
  const [locationQuery, setLocationQuery] = useState('');
  const [ethnicityQuery, setEthnicityQuery] = useState('');
  const [veteran, setVeteranQuery] = useState('');
  const [lgbtq, setLgbtqQuery] = useState('');
  const [gender, setGenderQuery] = useState('');
  const [searching, setSearching] = useState(false);
  const timeout = useRef();

  const onSubmit = (evt) => {
    evt.preventDefault();
  }

  const findUserData = ({ target: { value } }) => {
    setSearching(true);
    clearTimeout(timeout.current);
    setQuery(value);
    timeout.current = setTimeout(async () => {
      const { data } = await axios.post(apiEndpoint('/search/users'), {
      q: value && value.trim().replace(' ', '*'),
      skillQuery,
      locationQuery,
      ethnicity: ethnicityQuery,
      veteran: veteran ? { checked: veteran } : null,
      gender,
      lgbtq: lgbtq ? { checked: lgbtq } : null
    });
    setUserData(data);
    setSearching(false);
    }, 700);
  };

  const findSkillData = async (value) => {
    setSearching(true);
    clearTimeout(timeout.current);
    setSkillQuery(value);
    const { data } = await axios.post(apiEndpoint('/search/users'), {
      q: query && query.trim().replace(' ', '*'),
      skillQuery: value,
      locationQuery,
      ethnicity: ethnicityQuery,
      veteran: veteran ? { checked: veteran } : null,
      gender,
      lgbtq: lgbtq ? { checked: lgbtq } : null
    });
    setUserData(data);
    setSearching(false);
  };

  const findLocationData = async ({ target: { value } }) => {
    setSearching(true);
    clearTimeout(timeout.current);
    setLocationQuery(value);
    timeout.current = setTimeout(async () => {
      const { data } = await axios.post(apiEndpoint('/search/users'), {
      q: query && query.trim().replace(' ', '*'),
      skillQuery,
      locationQuery: value && value.length > 3 ? value : '',
      ethnicity: ethnicityQuery,
      veteran: veteran ? { checked: veteran } : null,
      gender,
      lgbtq: lgbtq ? { checked: lgbtq } : null
    });
    setUserData(data);
    setSearching(false);
    }, 700);
  };

  const findEthnicityData = async (value) => {
    setSearching(true);
    clearTimeout(timeout.current);
    setEthnicityQuery(value);
    const { data } = await axios.post(apiEndpoint('/search/users'), {
      q: query && query.trim().replace(' ', '*'),
      skillQuery,
      locationQuery,
      ethnicity: value,
      veteran: veteran ? { checked: veteran } : null,
      gender,
      lgbtq: lgbtq ? { checked: lgbtq } : null
    });
    setUserData(data);
    setSearching(false);
  };

  const findVeteranData = async ({ target: { checked } }) => {
    setSearching(true);
    clearTimeout(timeout.current);
    setVeteranQuery(checked);
    const { data } = await axios.post(apiEndpoint('/search/users'), {
      q: query && query.trim().replace(' ', '*'),
      skillQuery,
      locationQuery,
      ethnicity: ethnicityQuery,
      veteran: { checked },
      gender,
      lgbtq: lgbtq ? { checked: lgbtq } : null
    });
    setUserData(data);
    setSearching(false);
  };

  const findLgbtqData = async ({ target: { checked } }) => {
    setSearching(true);
    clearTimeout(timeout.current);
    setLgbtqQuery(checked);
    const { data } = await axios.post(apiEndpoint('/search/users'), {
      q: query && query.trim().replace(' ', '*'),
      skillQuery,
      locationQuery,
      ethnicity: ethnicityQuery,
      veteran: veteran ? { checked: veteran } : null,
      lgbtq: { checked },
      gender
    });
    setUserData(data);
    setSearching(false);
  };

  const findGenderData = async (value) => {
    setSearching(true);
    clearTimeout(timeout.current);
    setGenderQuery(value);
    const { data } = await axios.post(apiEndpoint('/search/users'), {
      q: query && query.trim().replace(' ', '*'),
      skillQuery,
      locationQuery,
      ethnicity: ethnicityQuery,
      veteran,
      lgbtq: lgbtq ? { checked: lgbtq } : null,
      gender: value
    });
    setUserData(data);
    setSearching(false);
  };

  const loadUserData = async () => {
    const { data } = await axios.post(apiEndpoint('/search/users'), {
      q: query && query.trim().replace(' ', '*'),
      skillQuery,
      locationQuery,
      ethnicity: ethnicityQuery,
      veteran: veteran ? { checked: veteran } : null,
      gender,
      lgbtq: lgbtq ? { checked: lgbtq } : null
    });
    setUserData(data);
    setSearching(false);
  };

  const loadEthnicities = async () => {
    const { data } = await axios.get(apiEndpoint('/admin/ethnicities'));
    setEthnicities(data.map(e => ({ value: e.id, label: e.ethnicity })));
  }

  const loadSkills = async () => {
    const { data } = await axios.get(apiEndpoint('/admin/skills'));
    setSkills(data.map(s => ({ value: s.id, label: s.name })))
  }

  useEffect(() => {
    loadUserData();
    loadEthnicities();
    loadSkills();
  }, []);

  return (
    <>
    <Helmet>
      <title>User Search | Productions.com</title>
    </Helmet>
      <div className="min-h-full">
        <Nav />
        <>
          <Header />
          <Aside />
          <main className="p-4 sm:ml-64 flex-shrink-0">
            <div className="mx-auto sm:px-6 lg:px-8">
              {/* Replace with your content */}
              <div>
                <div className="pb-2">
                  <form onSubmit={onSubmit}>
                    <div className="flex">
                    <div className="flex-auto">
                    <label
                      htmlFor="default-search"
                      className="text-md font-bold font-medium text-gray-900 dark:text-white"
                    >
                      General Search
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg
                          aria-hidden="true"
                          className="w-5 h-5 text-gray-500 dark:text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          ></path>
                        </svg>
                      </div>
                      <input
                        onChange={findUserData}
                        type="text"
                        id="default-search"
                        name="general-search"
                        className="block w-full p-6 px-10 text-lg text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Search Users..."
                      />
                    </div>
                    </div>
                    <div className="flex-auto">
                        <label
                          htmlFor="select-genders"
                          className="block text-lg font-medium text-white">Gender</label>
                        <Select
                          id="select-genders"
                          name="select-genders"
                          placeholder="Select Gender"
                          className="block px-10 p-3"
                          value={gender}
                          onChange={findGenderData}
                          options={genderOptions.map(g => ({ value: g, label: g }))}
                          isClearable>
                        </Select>
                      </div>
                    <div className="w-half m-2 block p-6 px-10">
                    <div>
                        <label className="text-gray-700 font-bold m-2">Veteran</label>
                        <input
                          onChange={findVeteranData}
                          type="checkbox"
                          id="veteran-search"
                          name="veteran-search"
                          className="text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        />
                      </div>
                    <div>
                        <label className="text-gray-700 font-bold m-2">LGBTQ+</label>
                        <input
                          onChange={findLgbtqData}
                          type="checkbox"
                          id="lgbtq-search"
                          name="lgtbq-search"
                          className="text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        />
                    </div>
                    </div>
                    </div>
                    <div className="flex">
                      <div className="flex-auto">
                        <label className="text-md font-bold font-medium text-gray-900 dark:text-white">Location</label>
                        <input
                          onChange={findLocationData}
                          type="text"
                          id="location-search"
                          name="location-search"
                          className="block w-full p-6 px-10 text-lg text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          placeholder="Search Location..."
                        />
                      </div>
                      <div className="flex-auto">
                        <label
                          htmlFor="skills"
                          className="block mb-2 text-lg font-medium text-white">Skills</label>
                        <Select
                          id="skills"
                          name="skills"
                          placeholder="Select Skills"
                          className="block w-full px-10 p-3"
                          value={skillQuery}
                          onChange={findSkillData}
                          options={skills}
                          isMulti>
                        </Select>
                      </div>
                      <div className="flex-auto">
                        <label
                          htmlFor="active-employers"
                          className="block text-lg font-medium text-white">Ethnicity</label>
                        <Select
                          id="ethnicities"
                          name="ethnicities"
                          placeholder="Select Ethnicity"
                          className="block w-full px-10 p-3"
                          value={ethnicityQuery}
                          onChange={findEthnicityData}
                          options={ethnicities}
                          isClearable>
                        </Select>
                      </div>
                    </div>
                  </form>
                </div>
                {userData && userData.length ? (
                  <UserSearchTable userData={userData} searching={searching} />
                ) : (
                  <div className="w-full">
                    <div className="mx-auto">Loading Users...</div>
                  </div>
                )}
              </div>
              {/* /End replace */}
            </div>
            <ProdzFooter />
          </main>
        </>
      </div>
    </>
  );
}

export default connector(UserSearch);